<template>
  <div class="container">
    <title-block title="Project Status" class="accountstitle" :callback="GetOrRefreshData"></title-block>
    <b-field grouped>
      <b-field label="Selecteer een Project">
        <b-select placeholder="Klik om te Selecteren..." v-model="selectedProject">
          <option v-for="option in projects" :value="option" :key="option.projectId">{{ option.name }}</option>
        </b-select>
      </b-field>
      <b-field label="Selecteer een begindatum">
        <b-datepicker icon="calendar-today" placeholder="Klik om te Selecteren..." v-model="dates[0]"></b-datepicker>
      </b-field>
      <b-field label="Selecteer een einddatum">
        <b-datepicker icon="calendar-today" placeholder="Klik om te Selecteren..." v-model="dates[1]"></b-datepicker>
      </b-field>
      <b-field>
        <p class="control">
          <button
            class="button buttonPro"
            @click="getProjectStatus"
            :disabled="isEmpty(selectedProject) || dates.length == 0 || dates.length == 1"
          >
            Status Overzicht
          </button>
        </p>
      </b-field>
    </b-field>
    <hr />
    <div class v-for="(building, index) in buildings" :key="building.id">
      <div class="columns is-gapless">
        <div class="column tableSec">
          <div v-if="tableVis">
            <project-status-table
              :data="data[index]"
              :columns="columns[index]"
              :rowIndication="rowIndication[index]"
            ></project-status-table>
          </div>
        </div>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ProjectService from '../../services/projectService'
import TitleBlock from '@/components/General/TitleBlock'
import ProjectStatusTable from './ProjectStatusTable'
import _ from 'lodash'

export default {
  components: {
    TitleBlock,
    ProjectStatusTable
  },

  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  data() {
    return {
      projects: [],
      isLoading: false,
      dates: [],
      selectedProject: {},
      data: [{ 0: '1', 1: '2', 2: '3' }],
      columndata: [],
      tableVis: false,
      buildings: [],
      columns: [],
      rowIndication: []
    }
  },

  computed: {
    dataIsEmpty: function() {
      if (this.data.length == 0) return true
      return false
    }
  },

  async beforeCreate() {
    await this.$store.dispatch('getBearerToken')
    ProjectService.getProjectList().then(res => {
      this.projects = res.data.projects
    })
  },

  methods: {
    isEmpty(obj) {
      return _.isEmpty(obj)
    },

    setColumns() {
      const mode = 0
      let startDate
      let endDate
      if (this.dates != null) {
        startDate = new Date(this.dates[0])
        startDate.setDate(startDate.getDate())
        endDate = new Date(this.dates[1])
        endDate.setDate(endDate.getDate())
      } else return
      this.columndata = []
      let startDateDay = startDate.getDay()
      let endDateDay = endDate.getDay()
      let diffTime = Math.abs(endDate - startDate)
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      let startDate2 = new Date()
      let daysToAdd
      if (startDateDay != 0) {
        daysToAdd = startDateDay - 1
        diffDays = diffDays + daysToAdd
        startDate2 = new Date(startDate.getTime())
        startDate2 = startDate2.setDate(startDate.getDate() - daysToAdd)
      } else {
        daysToAdd = startDateDay + 6
        diffDays = diffDays + daysToAdd
        startDate2 = new Date(startDate.getTime())
        startDate2 = startDate2.setDate(startDate.getDate() - daysToAdd)
      }

      for (let i = 0; i <= diffDays; i++) {
        let meta = false
        if (i < daysToAdd) meta = true
        let startDate3 = new Date()
        startDate3.setTime(startDate2 + i * 60 * 60 * 24 * 1000 + 60 * 60 * 5 * 1000)
        console.log(startDate2, startDate3, startDate3.toISOString().split('T')[0])
        this.columndata.push({
          field: startDate3.toISOString().split('T')[0],
          label: this.intToDay(i % 7) + '\n' + startDate3.getDate().toString(),
          centered: true,
          width: 44,
          meta: meta
        })
      }
      this.tableVis = true
    },
    intToDay(value) {
      switch (value) {
        case 0:
          return 'Ma'
        case 1:
          return 'Di'
        case 2:
          return 'Wo'
        case 3:
          return 'Do'
        case 4:
          return 'Vr'
        case 5:
          return 'Za'
        case 6:
          return 'Zo'
      }
    },
    GetOrRefreshData() {},
    createData() {
      let i = 0
      this.buildings.forEach(element => {
        this.data[i] = []
        this.columns[i] = [...this.columndata]
        this.columns[i].splice(0, 0, {
          field: 'Titles',
          label: `Gebouw ${element.building}`,
          width: 200,
          renderHtml: true
        })
        this.rowIndication[i] = []
        let j = 0
        element.floors.forEach(ele => {
          ele.zones.forEach(e => {
            this.data[i].push(
              Object.assign(
                {
                  Titles: `<b>${this.$options.filters.capitalize(ele.floor)}</b> - ${e.zone}`
                },
                e.dataDone
              )
            )
            this.rowIndication[i].push(j)
            j++
          })
        })
        i++
      })
    },
    async getProjectStatus() {
      const mode = 0
      let startDate
      let startDateStr
      let endDate
      let endDateStr
      if (this.dates != null) {
        startDate = new Date(this.dates[0])
        startDate.setDate(startDate.getDate())
        startDateStr = startDate.toISOString().split('T')[0]
        endDate = new Date(this.dates[1])
        endDate.setDate(endDate.getDate())
        endDateStr = endDate.toISOString().split('T')[0]
      } else return
      let payload = {
        mode: mode,
        projectId: this.selectedProject.projectId,
        startDate: startDateStr,
        endDate: endDateStr
      }
      const res = await ProjectService.getProjectStatus(payload)

      var _vm = this
      var result = res.data.status
      this.buildings = []
      var i = 0
      result.forEach(function(b) {
        _vm.buildings.push({ building: b[0].building, floors: [] })

        for (i = 0; i < b.length; i++) {
          if (!_vm.buildings.find(e => e.building == b[0].building).floors.some(x => x.floor == b[i].floor)) {
            _vm.buildings.find(e => e.building == b[0].building).floors.push({ floor: b[i].floor, zones: [] })
          }
          if (
            !_vm.buildings
              .find(e => e.building == b[0].building)
              .floors.find(e => e.floor == b[i].floor)
              .zones.some(x => x.zone == b[i].zone)
          ) {
            _vm.buildings
              .find(e => e.building == b[0].building)
              .floors.find(e => e.floor == b[i].floor)
              .zones.push({ zone: b[i].zone, dataNotDone: {}, dataDone: {} })
          }
          function assignKey(obj, key) {
            typeof obj[key] === 'undefined' ? (obj[key] = 1) : obj[key]++
          }
          if (b[i].status == 5) {
            assignKey(
              _vm.buildings
                .find(e => e.building == b[0].building)
                .floors.find(e => e.floor == b[i].floor)
                .zones.find(e => e.zone == b[i].zone).dataDone,
              b[i].datePhoto.split('T')[0]
            )
          } else {
            assignKey(
              _vm.buildings
                .find(e => e.building == b[0].building)
                .floors.find(e => e.floor == b[i].floor)
                .zones.find(e => e.zone == b[i].zone).dataNotDone,
              b[i].datePhoto.split('T')[0]
            )
          }
        }
      })
      this.setColumns()
      this.createData()
    }
  }
}
</script>

<style lang="scss" scoped>
.tableSec {
  overflow-x: auto;
}
.buttonPro {
  margin-top: 32px;
  float: right;
}
th:first-child {
  padding-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/Office/ProjectStatus.vue